import ResourceImage from "./resourceImage";


function ResourceTipsClassSuccess() {

  return (
    <div class='body-container resource'>

      <div class='flex-row' style={{alignItems: 'flex-start'}}>
        <h2>Tips To Make FLOW Speak Successful In Your Class</h2>
        <button class='icon icon-printer' onClick={() => window.print()} title='Print' style={{marginLeft: '15px'}} />
      </div>


      <p>Ready to use FLOW Speak with your class? Here are some helpful tips to be successful and get your students engaged.</p>

      {/* - */}

      <h3>The Basics</h3>

      <p>
        Your students can use FLOW Speak on any device. They can access the web version on a desktop computer, a laptop computer, or a mobile device at <a href="https://app.flowspeak.io/" target="_blank">https://app.flowspeak.io</a>.
      </p>

      <p>There is also a mobile app that students can download and use:</p>

      <ul>
        <li>
          Android - <a href="https://play.google.com/store/apps/details?id=com.flow_app" target="_blank">https://play.google.com/store/apps/details?id=com.flow_app</a>
        </li>
        <li>
          IOS - <a href="https://apps.apple.com/us/app/flow-speak/id1639740192" target="_blank">https://apps.apple.com/us/app/flow-speak/id1639740192</a>
        </li>
      </ul>

      <p>
        <i>Students should use the same email address and password on both the mobile app and the web version.</i>
      </p>

      {/* - */}

      <h3>Make it meaningful</h3>

      <p>
        If possible, give a grade or extra credit for completing FLOW Speak lessons. This will help motivate students and help to draw a connection between what they learn in class and practice on to use the app.
      </p>

      <p>
        Consider making the grade a mix of the number of lessons completed and the final score they get per lesson. We recommend advising students to aim for over 80% scores for each lesson completed, which shows up as an ‘excellent’ evaluation. Remind students to retry as many times as needed to get a high score. Repetition is the key to speaking skills improvement!
      </p>

      <p>
        For reference, the evaluation and scoring for individual responses and completed lessons is as follows:
      </p>

      <div>
        <div class='flex-row' style={{justifyContent: 'flex-start'}}>
          <p style={{width: '130px'}}><strong>Evaluation</strong></p>
          <p><strong>Score</strong></p>
        </div>
        <div class='flex-row' style={{justifyContent: 'flex-start'}}>
          <p style={{width: '130px'}}>Excellent</p>
          <p>80% or more</p>
        </div>
        <div class='flex-row' style={{justifyContent: 'flex-start'}}>
          <p style={{width: '130px'}}>Good</p>
          <p>60 - 79%</p>
        </div>
        <div class='flex-row' style={{justifyContent: 'flex-start'}}>
          <p style={{width: '130px'}}>Ok</p>
          <p>59% or less</p>
        </div>
      </div>

      {/* - */}

      <h3>Use FLOW Speak In Class</h3>

      <p>
        You can use FLOW Speak in class or after class. Using FLOW Speak in class will let you spend time with students to answer questions and help guide them until they feel comfortable using the app.  Here are some key things that can do:
      </p>

      <p>
        <strong>Dedicate time</strong>
        <br />
        Create a dedicated block of time for each class when you will use FLOW Speak. Make this a consistent part of your class so students look forward to it.
      </p>

      <p>
        <strong>Start together</strong>
        <br />
        The first time you use FLOW Speak, spend some time to make sure everyone has their account set up and is logged in. Then do the first lesson together to show how to use the app.
      </p>
      <p>
        Students will likely use the app the way you show them, so this is an important step. When taking a lesson, be sure to highlight how to view feedback and retry a response.
      </p>

      <div class='flex-row guide-image-container'>
        <ResourceImage imageUrl={'https://files.flowspeak.io/files/resources/lesson-view-feedback.jpg'} />
        <ResourceImage imageUrl={'https://files.flowspeak.io/files/resources/lesson-view-feedback-2.jpg'} />
        <ResourceImage imageUrl={'https://files.flowspeak.io/files/resources/lesson-view-feedback-3.jpg'} />
        <ResourceImage imageUrl={'https://files.flowspeak.io/files/resources/lesson-view-feedback-4.jpg'} />
      </div>



      <p>
        <strong>Use headphones</strong>
        <br />
        Ask your students to bring headphones or earpods. This will help keep the room quiet and ensure the voice transcription works smoothly for each student.
      </p>

      <p>
        <strong>Work on specific lessons</strong>
        <br />
        Ask everyone to do the same lesson(s) so that everyone is having a shared experience. You can pick lessons from the current week or from the Library.
      </p>

      <p>
        <strong>Discuss afterwards </strong>
        <br />
        After your students have finished the lesson(s), take some time to discuss the lesson as a class. Try to reinforce the topic of the lesson and review relevant vocabulary.
      </p>

      {/* - */}

      <h3>Use FLOW Speak Outside Of Class</h3>

      <p>
        FLOW Speak works great as after class speaking practice. You can assign speaking homework to your students so they can reinforce what they learned in class. Here are some tips for success:
      </p>

      <p>
        <strong>Start together</strong>
        <br />
        When you first start using FLOW Speak, it’s important to take some time in class to introduce the app and ensure all your students are set up and logged in. Do at least one lesson together and help answer any questions.
      </p>
      <p>
        Students will likely use the app the way you show them, so this is an important step. When taking a lesson, be sure to highlight how to view feedback and retry a response.
      </p>

      <p>
        <strong>Assign the weekly lessons</strong>
        <br />
        Assign specific lessons and show students where those lessons are. The easiest option is to assign this week’s lessons on the Home screen.
      </p>
      <p>
        Whether you chose the Pathways or a Course curriculum, the Home screen will have a This Week section with several lessons students can take.
      </p>

      <div class='flex-row guide-image-container'>
        <ResourceImage imageUrl={'https://files.flowspeak.io/files/resources/weekly-lessons.jpg'} />
      </div>



      <p>
        <strong>Review in class</strong>
        <br />
        Each class, take a few minutes to discuss the FLOW Speak lessons that students were previously assigned. Discuss what they learned, answer and questions, and review useful vocabulary or ideas.
      </p>

      {/* - */}

      <h3>Leaderboard</h3>

      <p>
        Some teachers like to create a leaderboard to generate some friendly competition. You can review your students’ activity in the FLOW Admin and then update your leaderboard each week.
      </p>

      <p>
        The leaderboard can be as simple as a written list on a whiteboard. If your class is online, you can make a Google Doc that you keep updated or use a free online tool like <a hre='keepthescore.com' target="_blank">keepthescore.com</a>.
      </p>

      {/* - */}

      <h3>Review Student Activity</h3>

      <p>
        Be sure to get the most out of the FLOW Admin by reviewing your students' activity. In the FLOW Admin, view the Learners list in the Group to see an overview of each learners:
      </p>

      <ul>
        <li>Total lessons completed</li>
        <li>Average score</li>
        <li>Average retires</li>
        <li>Date of the last lesson they completed</li>
        <li>Course activity</li>
      </ul>

      <p>
        You can also click the “eye” icon next to each student to view all the courses and lessons they have completed and the scores per lesson. <i>You can also listen to their audio recordings so you can give additional feedback</i>.
      </p>

      <div class='flex-row guide-image-container'>
        <ResourceImage imageUrl={'https://files.flowspeak.io/files/resources/view-group.jpg'} />
        <ResourceImage imageUrl={'https://files.flowspeak.io/files/resources/view-group-2.jpg'} />
        <ResourceImage imageUrl={'https://files.flowspeak.io/files/resources/view-group-3.jpg'} />
      </div>



      {/* - */}

      <h3>One-On-One Coaching</h3>

      <p>
        For teachers who are able to offer one-on-one coaching to their students, print out the data from the FLOW Admin. Also be sure to listen to some of the student's responses. Use this information to give specific feedback.
      </p>

      <div class='flex-row guide-image-container'>
        <ResourceImage imageUrl={'https://files.flowspeak.io/files/resources/view-group-export.jpg'} />
        <ResourceImage imageUrl={'https://files.flowspeak.io/files/resources/view-group-export-2.jpg'} />
      </div>


    </div>
  );
}

export default ResourceTipsClassSuccess;